<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container fluid>
            <v-card>
                <v-card-text>
                    <h1>D/R Balance</h1>
                    <hr>
                    <!-- <v-btn @click="test"></!-->
                    <!-- Search report -->
                    <div>
                        <v-layout justify-center>
                            <v-flex xs2>
                                <v-autocomplete label="Customer code:" :items="itemCustCode" v-model="custCode"></v-autocomplete>
                            </v-flex>
                            <v-flex xs2>
                                <v-menu v-model="menuStartDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                                offset-y full-width min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="startDate" label="Start date:" prepend-icon="event" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="startDate" @input="menuStartDate = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs2>
                                <v-menu v-model="menuEndDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                                offset-y full-width min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="endDate" label="Ending date:" prepend-icon="event" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="endDate" @input="menuEndDate = false" :min ="startDate" :max="nowDate"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex>
                                <v-btn fab small color="indigo lighten-1" dark @click="getGl"><v-icon>search</v-icon></v-btn>
                            </v-flex>
                        </v-layout>
                        <hr>
                    </div>

                    <!-- Detail report gl -->
                    <div v-if="showDetial">

                        <!-- Report gl detail -->
                        <div>
                            <v-layout>
                                <v-flex xs10 text-xs-right pr-4>
                                    <font color="red">B/F:</font>
                                </v-flex>
                                <v-flex pr-4>
                                    <font color="red">
                                        <vue-numeric :value="balance.toString()" separator="," :precision="2" class="numericBalance" disabled></vue-numeric>
                                    </font>
                                </v-flex>
                            </v-layout>
                        </div>
                        <hr>
                        <div>
                            <v-data-table :headers="headerDetail" :items="detail" class="elevation-1" :rows-per-page-items="rowsPerPageItems">
                                <template v-slot:items="props">
                                    <td>{{props.item.glDate.substr(0,10)}}</td>
                                    <td>{{props.item.refNo}}</td>
                                    <td>{{props.item.custCode}}</td>
                                    <td>{{props.item.desc}}</td>
                                    <td class="text-xs-right">{{props.item.debit.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                    <td class="text-xs-right">{{props.item.credit.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                    <td class="text-xs-right">{{props.item.balance.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                </template>
                                <template v-slot:footer>
                                    <td><strong>Total:</strong></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-xs-right"><strong>{{net.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-container>
    </v-app>
</template>
<script>
import {db} from '@/firebase'
import VueNumeric from 'vue-numeric'
import mainMenu from '@/components/mainMenu.vue'
export default {
    components:{
        mainMenu,
        VueNumeric
    },
    data(){
        return{
            nowDate: new Date().toISOString().slice(0,10),
            menuStartDate: false,
            menuEndDate: false,
            startDate: new Date().toISOString().substr(0, 10),
            endDate: new Date().toISOString().substr(0, 10),

            itemCustCode: [],
            custCode: '',

            showDetial: false,
            balance: 0,
            rowsPerPageItems: [30,50,100,200],
            headerDetail:[
                { text: 'Date', align: 'left', value: 'glDate' },
                { text: 'Ref no', align: 'left', value: 'refNo' },
                { text: 'Customer code', sortable: false, align: 'left' },
                { text: 'Description', sortable: false, align: 'left' },
                { text: 'Debit', sortable: false, align: 'right' },
                { text: 'Credit', sortable: false, align: 'right' },
                { text: 'Balance', sortable: false, align: 'right' }
            ],
            detail: [],
        }
    },
    methods:{

        // Get gl
        getGl(){
            this.showDetial = false
            this.balance = 0
            let app = this
            let year = this.startDate.substr(0, 4)
            if(this.custCode == ''){
                alert("Please enter customer code.")
            }
            else{
                db.collection("generalLedger").where("accId", "==", "214101").where("custCode", "==", this.custCode)
                .where("glDate", ">", year + "-01")
                .where("glDate", "<", this.startDate).get()
                .then(query=>{
                    let debit = 0
                    let credit = 0
                    query.forEach(doc=>{
                        debit += doc.data().debit
                        credit += doc.data().credit
                    })
                    this.balance = debit - credit
                    db.collection("generalLedger").where("accId", "==", "214101").where("custCode", "==", this.custCode)
                    .where("glDate", ">=", this.startDate).where("glDate", "<=", this.endDate).get()
                    .then(query=>{
                        this.detail = []
                        let bala = app.balance
                        query.forEach(doc=>{
                            let data = doc.data()
                            bala = bala*1+(data.debit-data.credit)
                            app.detail.push({...data,balance:bala})
                        })
                        if(app.detail.length == 0){
                            alert("Data not found.\nPlease try again.")
                        }
                        else{
                            app.showDetial = true
                        }
                    })
                })
            }
        }
    },
    computed:{

        total(){
            return this.detail.reduce((total,item)=> total+(item.debit - item.credit),0)
        },

        net(){
            return this.total + this.balance*1
        }
    },
    mounted(){
        db.collection("customer").get()
        .then(query=>{
            this.itemCustCode = []
            query.forEach(doc=>{
                this.itemCustCode.push(doc.data().code)
            })
            this.itemCustCode.sort()
        })
    }
}
</script>
<style scoped>
.padDing{
    padding: 0.5%;
}
.txtCenter{
    text-align: center;
}
.numeric{
    text-align: right;
    width: 100%;
    border-bottom: 1px solid black;
    padding: 1.5%;
}
.numericBalance{
    text-align: right;
    width: 100%;
}
.collapse:nth-child(even){
    background-color: #dddddd;
}
</style>